export enum BeneficiaryStatus {
  ExistEvidence,
  NoExistEvidence,
  NoExist,
}

export const beneficiaryStatusValues: { [id: number]: string } = {
  0: 'Si existencia de Beneficiario Controlador y exhibición de documentación oficial',
  1: 'Si existencia de Beneficiario Controlador y no exhibición de documentación oficial',
  2: 'No existencia de Beneficiario Controlador',
};
